import type { NitroFetchRequest, $Fetch } from 'nitropack'
import type { FetchOptions } from 'ofetch'

export const userRepository = <T>(fetch: $Fetch<T, NitroFetchRequest>) => ({
  async getWishList(
    options: FetchOptions & {
      params?: {
        sort_by: string // available, out_of_stock, all
        per_page: number
      }
    } = {}
  ): Promise<GetWishListResponseV2> {
    return fetch<GetWishListResponseV2>('/v2/storefront/customer/wishlist', {
      ...options,
      method: 'GET'
    })
  },

  async getWishListV3(
    options: FetchOptions & {
      params?: {
        sort_by: string // available, out_of_stock, all
        per_page: number
      }
    } = {}
  ): Promise<GetWishListResponseV2> {
    return fetch<GetWishListResponseV2>('/v3/storefront/customer/wishlist', {
      ...options,
      method: 'GET'
    })
  }
})
